import { ModuleConditionTypeEnum } from "../../../types";
import ConfigCondition from "../../ConfigCondition";
import { MessageContentTypeEnum } from "./types";

export default class MessageContentTypeCondition extends ConfigCondition {
  type = ModuleConditionTypeEnum.MessageContentType;

  values!: Array<MessageContentTypeEnum>
}
